import { __decorate, __metadata } from "tslib";
import { makeObservable, observable } from 'mobx';
var ViewParameter = /** @class */ (function () {
    function ViewParameter(parent, name, routeParameter) {
        this.parent = parent;
        this.name = name;
        this.routeParameter = routeParameter;
        this.hasPendingValue = false;
        this.pendingValue = null;
        this._value = null;
        this.prefixes = [];
        this._description = "";
        makeObservable(this);
    }
    ViewParameter.prototype.bindTo = function (propertyOrCallback) {
        var _this = this;
        if (propertyOrCallback.propertyInfo) {
            this.parent.view.viewModel.registerReaction(function () { return propertyOrCallback.value; }, function (val) { return _this.value = val; });
        }
        else if (propertyOrCallback instanceof Function) {
            this.parent.view.viewModel.registerReaction(propertyOrCallback, function (val) { return _this.value = val; });
        }
    };
    Object.defineProperty(ViewParameter.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            var stringValue;
            if (value instanceof Array) {
                stringValue = value.join(",");
            }
            else {
                stringValue = value ? value.toString() : null;
            }
            if (stringValue !== this._value) {
                this.hasPendingValue = true;
                this.pendingValue = stringValue;
                this.parent.setUrl(this);
            }
        },
        enumerable: false,
        configurable: true
    });
    ViewParameter.prototype.reset = function () {
        if (this._value) {
            this.hasPendingValue = true;
            this.pendingValue = null;
            this.parent.setUrl(this, true);
        }
    };
    Object.defineProperty(ViewParameter.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            if (this.hasPendingValue) {
                console.warn("Do not set view parameter description directly after setting value. Description should be set in the viewParamsUpdated() method.");
            }
            this._description = value;
        },
        enumerable: false,
        configurable: true
    });
    ViewParameter.prototype.setDescription = function (description, getPrefixes) {
        this.prefixes = getPrefixes ? getPrefixes(this.prefixes) : [];
        this.description = description;
    };
    ViewParameter.prototype.asNullableInt = function () {
        if (this._value) {
            return parseInt(this._value, 10);
        }
        return null;
    };
    ViewParameter.prototype.asString = function () {
        return this._value || "";
    };
    ViewParameter.prototype.asStringList = function () {
        if (this._value) {
            return this._value.split(",");
        }
        else {
            return [];
        }
    };
    /** Updates the current value, and returns true if the value changed. */
    ViewParameter.prototype.update = function (value) {
        if (value) {
            value = decodeURIComponent(value);
        }
        if (value != this._value) {
            this.hasPendingValue = false;
            this.pendingValue = value;
            this._value = value;
            if (!value) {
                this._description = "";
                this.prefixes = [];
            }
            return true;
        }
        return false;
    };
    ViewParameter.prototype.getParamString = function (state) {
        var value = this.latestValue;
        if (value) {
            value = encodeURIComponent(value);
            if (this.routeParameter.isQuery) {
                var hasQuery = state.hasQuery;
                state.hasQuery = true;
                return (!hasQuery ? "?" : "&") + this.name + "=" + value;
            }
            else {
                return "/" + value;
            }
        }
        return this.routeParameter.isQuery ? "" : "/";
    };
    Object.defineProperty(ViewParameter.prototype, "latestValue", {
        get: function () {
            return this.hasPendingValue ? this.pendingValue : this._value;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable.ref,
        __metadata("design:type", String)
    ], ViewParameter.prototype, "_description", void 0);
    return ViewParameter;
}());
export { ViewParameter };
